<template>
  <div :class="$style.wrap">
    <div class="base_title">
      <p>请填写需要注销的账号：</p>
    </div>
    <base-form
      ref="form"
      has-captcha
      :items="data"
      label-width="2em"
      submit-text="下一步"
      @submit="onSubmit"
    />
    <p class="again_text">
      <router-link :to="{ path: '/cancellationAccount', query: $route.query }">
        重新申请
      </router-link>
    </p>
  </div>
</template>
<script>
import { getAccountStatus } from "@/http/cancellation";
import BaseForm from "@/components/BaseForm";
export default {
  name: "Fill",
  components: { BaseForm },
  data() {
    return {
      checked: true, //是否同意
      data: [{ name: "userAccount" }]
    };
  },
  // 访问限制
  beforeRouteEnter(to, from, next) {
    if (from.name !== "cancellationAccount") {
      next({ path: "/cancellationAccount", query: to.query });
    } else {
      next();
    }
  },
  methods: {
    /**
     * @description 同意注销
     * @param {object} formdata  - 表单对象值
     * @param {object} validate  - 极致验证
     */
    async onSubmit(formdata, validate = {}, callback) {
      let { userAccount } = formdata;

      const parmas = {
        ...this.$route.query,
        login_code: userAccount,
        ...validate
      };

      getAccountStatus(parmas)
        .then(res => {
          if (callback) callback(res.rcode);
          if (res.rcode === 0 && res.data) {
            // 有条件 前往注销页面信息
            if (res.data.status === 0) {
              this.$router.replace({
                name: this._anchor.cancellationInfo.name,
                params: { info: JSON.stringify(res.data) },
                query: this.$route.query
              });
            } else if (res.data.status == 1 || res.data.status == 2) {
              // 1审核状态 // 2 已注销
              this.$router.replace({
                name: this._anchor.cancellationStatus.name,
                params: {
                  status: res.data.status,
                  info: JSON.stringify(res.data)
                },
                query: this.$route.query
              });
            }
          } else if (res.rcode === 3003) {
            setTimeout(() => {
              // 无连续操作 回退到上一个页面
              this.$router.replace({
                path: this._anchor.cancellationAccount.path,
                query: this.$route.query
              });
            }, 2000);
          } else if (res.rcode === 3001) {
            this.$router.replace({
              name: this._anchor.cancellationStatus.name,
              params: { status: 3 },
              query: this.$route.query
            });
          }
        })
        .catch(() => {
          this.$refs.form.validator.reset();
          this.$refs.form.disabled = false;
        })
        .finally(() => {
          if (this.$refs.form) {
            this.$refs.form.validator.reset();
            this.$refs.form.disabled = false;
          }
        });
    }
  }
};
</script>
<style lang="less" module>
.wrap {
  padding-top: 0.3rem;
}
</style>
